import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AuthBackgroundSemanticClass;
function AuthBackgroundSemantic() {
  if (AuthBackgroundSemanticClass === VOID) {
    class $ extends Semantic() {
      static vjp() {
        AuthBackgroundSemantic_instance = null;
        var $this = this.bd1('authback');
        AuthBackgroundSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp0_background = AppColors_getInstance().ffz_1.aga_1;
        return this.hd1(theme, false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'AuthBackgroundSemantic';
      }
      hashCode() {
        return 443928462;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthBackgroundSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AuthBackgroundSemantic');
    AuthBackgroundSemanticClass = $;
  }
  return AuthBackgroundSemanticClass;
}
var AuthBackgroundSemantic_instance;
function AuthBackgroundSemantic_getInstance() {
  if (AuthBackgroundSemantic_instance === VOID)
    AuthBackgroundSemantic().vjp();
  return AuthBackgroundSemantic_instance;
}
//region block: exports
export {
  AuthBackgroundSemantic_getInstance as AuthBackgroundSemantic_getInstance55rb2qz6vrk4,
};
//endregion

//# sourceMappingURL=auth.mjs.map
